import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../utils/Functions';
import { params } from '../../../../../redux/reducers/reducer';

const NinePanelWindow = ({ width, height, trimWidth, isOverlap, overlapTrimColor, glassTexture }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
    
    const windowWidth = width - trimWidth * 4
    const windowHeight = (height - trimWidth * 4) 

    const outTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, height / 2);
        model.lineTo(width / 2, height / 2);
        model.lineTo(width / 2, -height / 2);
        model.lineTo(-width / 2, -height / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        hole.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const insideTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        model.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.lineTo(-width / 2 + (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.closePath();
        
        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])
    
    const windowTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, -windowHeight / 2);
        model.lineTo(-windowWidth / 2, -windowHeight / 2);
        model.closePath();
        
        const hole = new THREE.Path();
        hole.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        hole.lineTo((windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        hole.lineTo((windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        hole.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        hole.closePath();

        model.holes.push(hole);

        return model;
    
    }, [width, height, trimWidth])

    const railModel = useMemo(() => {
        let model = [];

        const railThickness = trimWidth / 5 * 4
        const railWidth = width - trimWidth * 6;
        const railHeight = height - trimWidth * 6;
        const distanceX = (railWidth - railThickness * 2) / 6;
        const distanceY = (railHeight - railThickness * 2) / 3;

        Array(2).fill(0).map(( value, index) => {
            const horizontalUpperModel = new THREE.Shape();
            horizontalUpperModel.moveTo(-railWidth / 2, -railHeight / 2 + railThickness * index + distanceY * (index + 1));
            horizontalUpperModel.lineTo(-railWidth / 2, -railHeight / 2 + railThickness * (index + 1) + distanceY * (index + 1));
            horizontalUpperModel.lineTo(railWidth / 2, -railHeight / 2 + railThickness * (index + 1) + distanceY * (index + 1));
            horizontalUpperModel.lineTo(railWidth / 2, -railHeight / 2 + railThickness * index + distanceY * (index + 1));
            horizontalUpperModel.closePath();
            model.push(horizontalUpperModel);

        })

        const verticalLeftModel = new THREE.Shape();
        verticalLeftModel.moveTo(-(distanceX + railThickness), -railHeight / 2);
        verticalLeftModel.lineTo(-(distanceX + railThickness), railHeight / 2);
        verticalLeftModel.lineTo(-(distanceX), railHeight / 2);
        verticalLeftModel.lineTo(-(distanceX), -railHeight / 2);

        const verticalRightModel = new THREE.Shape();
        verticalRightModel.moveTo((distanceX + railThickness), -railHeight / 2);
        verticalRightModel.lineTo((distanceX + railThickness), railHeight / 2);
        verticalRightModel.lineTo((distanceX), railHeight / 2);
        verticalRightModel.lineTo((distanceX), -railHeight / 2);


        
        model.push(verticalLeftModel);
        model.push(verticalRightModel);

        return model;
    }, [width, height, trimWidth])


    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        model.lineTo((windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        model.lineTo((windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        model.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        model.closePath();

        return model
    
    }, [width, height, trimWidth])
    
    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[outTrimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='inside-trim'>
                <extrudeGeometry args={[insideTrimModel, extrudeSettings(0.4)]} />
                <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.2} />
            </mesh>

            {new Array(1).fill("").map((_, index) =>
                <group key={`rail-model-${index}`} name='rail-model' position={[0, 0, 0.1 + 0.1 * index]}>
                    <mesh name='pattern-rail'>
                        <extrudeGeometry args={[railModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial  color={'#ffffff'} side={THREE.DoubleSide} roughness={0.3} metalness={0.2} />
                    </mesh>
                </group>
            )}

            {new Array(1).fill("").map((_, index) =>
                <group key={`window-model-${index}`} name='window-model' position={[0, 0, 0.1 + 0.1 * index]}>
                    <mesh name='glass-trim'>
                        <extrudeGeometry args={[windowTrimModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.3}  />
                    </mesh>
                    <mesh name='glass' position={[0, 0, 0.01]}>
                        <extrudeGeometry args={[glassModel, extrudeSettings(0.08)]} />
                        <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
                    </mesh>
                </group>
            )}
        </>
    )
}

export default NinePanelWindow